<div class="wrapper">
  <h1>{{'YOUR_SESSION_HAS_BEEN_CLOSED' | translate}}</h1>
  <div>
    {{'ONLY_ONE_INSTANCE_OF_THIS_APP_IS_AUTHORIZED_PER_WORKSTATION' | translate}}
  </div>
  <div>
    {{ '10134' | translate }} <!--Due to a new connection, the session for this station was closed.-->
    <br/>
    {{ '10135' | translate }} <!--If you want to activate the session, you can use the button below.-->
  </div>

  <button (click)="reload()" class="btn">
    {{ 'REACTIVATE' | translate }}
  </button>
</div>
